module.exports = __webpack_public_path__ + "img/headDefault.457193c0.png";